"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchActivityDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _each = _interopRequireDefault(require("lodash/each"));
var _reject = _interopRequireDefault(require("lodash/reject"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _map = _interopRequireDefault(require("lodash/map"));
var _get = _interopRequireDefault(require("lodash/get"));
var _dropdownNavigationHoc = _interopRequireDefault(require("../dropdown-navigation-hoc"));
var _highlightWordsCore = require("highlight-words-core");
var _reactIntl = require("react-intl");
var _excluded = ["activitiesList"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ListContainer = function ListContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("ul", {
    tabIndex: "-1",
    role: "listbox",
    className: "dropdown-list",
    "aria-labelledby": null,
    style: {
      minWidth: '220px',
      margin: '0 -1px'
    }
  }, children);
};
var ErrorDropdown = function ErrorDropdown(_ref2) {
  var toggleModal = _ref2.toggleModal,
    listToggle = _ref2.listToggle;
  return /*#__PURE__*/_react.default.createElement(ListContainer, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.error_dropdown.dont_recognize_activity",
    defaultMessage: "We don't recognize that activity. Try describing it differently or"
  }), "\xA0", /*#__PURE__*/_react.default.createElement("span", {
    role: "button",
    className: "btn-link remove-click-styling no-gutter text-left",
    onClick: function onClick(e) {
      toggleModal(e, listToggle);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.error_dropdown.popular_activities",
    defaultMessage: "pick from popular activities."
  })))));
};
var ActivityList = (0, _dropdownNavigationHoc.default)(function (_ref3) {
  var data = _ref3.data,
    inputShownValue = _ref3.inputShownValue,
    clickActivity = _ref3.clickActivity,
    listToggle = _ref3.listToggle,
    index = _ref3.index,
    onKeyDownList = _ref3.onKeyDownList,
    hideDefaultHighlight = _ref3.hideDefaultHighlight;
  var dropdown = (0, _get.default)(data, 'dropdown', '');
  var chunks = (0, _highlightWordsCore.findAll)({
    caseSensitive: false,
    textToHighlight: dropdown,
    autoEscape: true,
    searchWords: [inputShownValue]
  });
  var highlightedText = (0, _map.default)(chunks, function (chunk) {
    var end = chunk.end,
      highlight = chunk.highlight,
      start = chunk.start;
    var text = dropdown.substr(start, end - start);
    if (highlight) {
      return /*#__PURE__*/_react.default.createElement("b", {
        className: "text-gray-darker"
      }, text);
    }
    return /*#__PURE__*/_react.default.createElement("span", null, text);
  });
  return /*#__PURE__*/_react.default.createElement("li", {
    key: data.id,
    id: "activity-list-".concat(index),
    tabIndex: "0",
    role: "option",
    "aria-selected": "true",
    className: "border-bottom ".concat(0 === index && !hideDefaultHighlight && 'gray-light-bg'),
    "data-value": data.id,
    onClick: function onClick(e) {
      clickActivity(e, listToggle);
    },
    onKeyDown: onKeyDownList,
    style: {
      padding: '10px 16px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ellipsis capitalize-first-letter"
  }, /*#__PURE__*/_react.default.createElement("div", null, highlightedText)));
});
var ActivitiesDropdown = function ActivitiesDropdown(_ref4) {
  var activitiesList = _ref4.activitiesList,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/_react.default.createElement(ListContainer, null, [(0, _map.default)(activitiesList, function (data, index) {
    return /*#__PURE__*/_react.default.createElement(ActivityList, _extends({
      key: data.nickname,
      data: data,
      index: index
    }, props));
  }), props.hideModalLink ? null : /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: "-1",
    style: {
      padding: '10px 16px'
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn-link remove-click-styling no-gutter",
    onClick: function onClick(e) {
      props.toggleModal(e, props.listToggle);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "search.activities_dropdown.popular_activities",
    defaultMessage: "See all popular activities"
  })))]);
};
var SearchActivityDropdown = exports.SearchActivityDropdown = function SearchActivityDropdown(_ref5) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref5), _ref5));
  var Component = props.activitiesList.length ? ActivitiesDropdown : !props.hideErrorDropdown && ErrorDropdown;
  return Component && /*#__PURE__*/_react.default.createElement(Component, props);
};
ErrorDropdown.propTypes = {
  listToggle: _propTypes.default.func,
  toggleModal: _propTypes.default.func
};
ActivityList.propTypes = {
  clickActivity: _propTypes.default.func.isRequired,
  data: _propTypes.default.object,
  inputShownValue: _propTypes.default.string,
  listToggle: _propTypes.default.func,
  index: _propTypes.default.number,
  onKeyDownList: _propTypes.default.number,
  hideDefaultHighlight: _propTypes.default.bool
};
ActivitiesDropdown.propTypes = {
  activitiesList: _propTypes.default.array,
  listToggle: _propTypes.default.func,
  toggleModal: _propTypes.default.func
};
ListContainer.propTypes = {
  children: _propTypes.default.node.isRequired
};
SearchActivityDropdown.propTypes = {
  activitiesList: _propTypes.default.array
};